module.exports = __webpack_public_path__ + "img/bquiklogo.14e26390.svg";